/**
 * Google Translate
 */
const $ = window.jQuery;
import cookie from "./_cookies";

// Element initialize
window.GoogleTranslateElementInit = function () {
  const googtrans = cookie.get("googtrans");
  let pageLanguage = "en";
  if (googtrans) {
    const translation = googtrans.split("/").filter(Boolean);
    pageLanguage = translation[1];
  }

  new google.translate.TranslateElement(
    {
      pageLanguage: pageLanguage,
    },
    "google_translate_element"
  );

  setTimeout(determineLanguage, 1000);
};

// Update language
function languageSwitcher() {
  $(document).on("click", "[data-translate]", (event) => {
    const toLanguage = $(event.currentTarget).attr("data-translate");
    const fromLanguage = toLanguage === "en" ? "es" : "en";
    window.location = `#googtrans(${fromLanguage}|${toLanguage})`;
    location.reload();
  });
}

// Determine language onload
function determineLanguage() {
  let language = {
    current: {
      code: "",
      label: "",
    },
    other: {
      code: "",
      label: "",
    },
  };

  // Update state after reload
  const currentLanguage = $("select.goog-te-combo option:selected").val();

  // Spanish
  if (currentLanguage === "es") {
    language.current.code = "es";
    language.current.label = "Spanish";
    language.other.code = "en";
    language.other.label = "English";
  }

  // English
  else {
    language.current.code = "en";
    language.current.label = "English";
    language.other.code = "es";
    language.other.label = "Spanish";
  }

  const $translate = $("button[data-translate]");
  $translate.attr("title", `Translate to ${language.other.label}`).attr("data-translate", `${language.other.code}`);
  $("span", $translate).text(language.other.label);
  $("strong", $translate).text(`Translate to ${language.other.label}`);

  if (cookie.get("googtrans")) {
    const wildcard = "." + location.host.split(".").slice(1).join(".");
    cookie.remove("googtrans", { path: "/", domain: "" });
    cookie.remove("googtrans", { path: "/", domain: wildcard });
  }

  if (location.hash.includes("#googtrans")) {
    history.pushState("", document.title, window.location.pathname + window.location.search);
  }

  $(`.skiptranslate`).find(`a`).attr(`rel`, "noopener");
}

// Load script
export function googleTranslate() {
  languageSwitcher();
  $.getScript("https://translate.google.com/translate_a/element.js?cb=GoogleTranslateElementInit");
}
